/* Mapping menu item icon from label */
export const menuIconMapper = label => {
    const menuIcons = {
        home: 'dashboard',
        approvals: 'approval',
        company_payments: 'coin-drop',
        accounts: 'group',
        transfers: 'transfer',
        payments: 'payment-single',
        cards: 'credit-card',
        cards_batchfile_new_charge: 'card-recharge',
        credits: 'bills',
        savings: 'pig',
        bankassurance: 'shield',
        contacts: 'phone',
        exchanges: 'coin',
        agencies: 'pin-drop',
        favorites: 'star',
        userArea_profile: 'manage-accounts',
        userArea_definitions: 'settings',
        userArea_acessionManagement: 'more-settings'
    }

    return menuIcons[label] || null
}

/* Mapping menu item icon for thirdLevel Menu from label */
export const menuIconThirdLevelMapper = label => {
    const menuIcons = {
        transfers_nacional: 'transfers_nacional',
        transfers_international: 'transfers-international',
        transfers_internationalCorporate: 'transfers-international',
        transfers_instantBAI: 'transfers-instant',
        transfers_kwik_transfer: 'transfers-kwik',
        transfers_kwik_manageAccounts: 'transfers-kwik-manageAccounts',
        payments_bai_paga: 'payments-bai-paga',
        payments_services: 'payments-services',
        payments_state: 'payments-state',
        payments_reference: 'payments-reference',
        payments_eKwanza: 'payments-charge-ekwanza',
        payments_wallet: 'wallet-charge',
        payments_requests: 'emptyState/available-soon',
        payments_history: 'emptyState/available-soon',
        transfers_requests_international: 'transfers-international',
        transfers_requests_internationalCorporate: 'transfers-international',
        transfers_requests_nacional: 'transfers_nacional',
        cards_cardless_withdraw_generate_code: 'cards',
        cards_cardless_withdraw_my_codes: 'cards-withdraw',
        cards_batchfile_new_charge_flex: 'cards-flex',
        cards_batchfile_new_charge_kamba: 'cards-kamba',
        cards_batchfile_new_charge_multicaixa: 'cards-multicaixa',
        bankassurance_subscribe_auto: 'bankassurance-auto',
        bankassurance_subscribe_travel: 'bankassurance-travel',
        bankassurance_subscribe_health: 'bankassurance-health',
        userArea_definitions_activeChannels: 'definitions-active-channels',
        userArea_definitions_passwordChange: 'definitions-password',
        userArea_definitions_friendlyUsername: 'definitions-username',
        userArea_definitions_accountGroups: 'definitions-accounts-groups',
        userArea_definitions_history: 'definitions-history',
        userArea_definitions_secureAssociationEnrollment: 'secure-association',
        userArea_definitions_notifications: 'definitions-notifications'
    }

    return menuIcons[label] || null
}
